import React from "react";
import "../../css/Button.css";

const ButtonSecondary = ({
  text,
  variant = "primary",
  onClick,
  className = "",
  type = "button",
  ...props
}) => {
  return (
    <button
      type={type}
      className={`pf-button secondary pf-button-${variant} ${className}`}
      onClick={onClick}
      {...props}
      >
          <div className="content-semibold">
            {text}
          </div>
    </button>
  );
};

export default ButtonSecondary;
